import React, { useState } from "react";
import { useMyContext } from "../../context/MyContext";
import { Viewer } from "@toast-ui/react-editor";

const TermsModal = ({ isOpen }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const {
    user,
    updateTermsAcceptance,
    setShowTermsModal,
    logout,
    termsAccepted,
    globalTerms,
    isNewTerms,
  } = useMyContext();



  if (!isOpen) return null;

  const handleClose = () => {
    setShowTermsModal(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && termsAccepted) {
      handleClose();
    }
  };

  const handleAccept = async () => {
    if (isChecked && user) {
      await updateTermsAcceptance(user.uid);
      // Password change modal is now handled in the updateTermsAcceptance function
      // Don't set it directly here
    }
  };

  const handleLogout = () => {
    setShowConfirmationModal(true);
  };

  const confirmLogout = () => {
    logout();
  };

  const closeConfirmationModal = () => {
    setShowConfirmationModal(false);
  };


  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50"
      onClick={handleOverlayClick}
      style={{ zIndex: 9999 }}
    >
      <div className="bg-white p-8 rounded-lg shadow-xl w-[90%] max-w-4xl max-h-[90vh] overflow-y-auto border border-blue-100">
        <div className="flex items-center justify-between border-b border-blue-100 pb-4 mb-4">
          <div>
            <h2 className="text-2xl font-bold text-blue-700">

              {isNewTerms ? "We've updated our Terms and Conditions" : "Terms and Conditions"}
            </h2>
            {isNewTerms && (
              <p className="text-sm text-gray-600 mt-1">
                Please review and accept the updated terms and conditions
              </p>
            )}
          </div>
          {termsAccepted && (
            <button
              className="text-gray-500 hover:text-blue-700 transition-colors"
              onClick={handleClose}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>

        <Viewer initialValue={globalTerms?.content} />

        {/* <div className="mt-4 text-sm text-gray-700 terms-content bg-blue-50 p-6 rounded-lg shadow-inner">
          <h1 className="text-2xl font-bold mb-4 text-blue-800">ONE UNION SOLUTIONS SYSTEM TERMS OF USE</h1>
          <p className="mb-4">
            THE FOLLOWING TERMS AND CONDITIONS GOVERN YOUR USE OF THE ONE UNION SOLUTIONS PLATFORM, INCLUDING YOUR USE OF THE SERVICES AND CONTENT. YOUR VIEWING OR USE OF THIS PLATFORM WILL CONSTITUTE YOUR AGREEMENT, ON BEHALF OF YOURSELF AND THE ENTITY YOU REPRESENT (HEREINAFTER COLLECTIVELY "YOU" OR "YOUR"), TO ALL OF THE TERMS AND CONDITIONS PROVIDED BELOW.
          </p>
          <p className="mb-4">
            ONE UNION SOLUTIONS MAY MAKE FUTURE CHANGES OR MODIFICATIONS TO SUCH TERMS AND CONDITIONS AT ANY TIME WITHOUT NOTICE, AND YOUR SUBSEQUENT VIEWING OR USE OF THE ONE UNION SOLUTIONS PLATFORM WILL CONSTITUTE YOUR AGREEMENT TO THE CHANGES AND MODIFICATIONS. THERE MAY BE ADDITIONAL TERMS AND CONDITIONS PROVIDED THROUGHOUT THE PLATFORM GOVERNING YOUR USE OF PARTICULAR FUNCTIONS, FEATURES, INFORMATION AND APPLICATIONS AVAILABLE THROUGH THE ONE UNION SOLUTIONS PLATFORM.
          </p>

          <h2 className="text-xl font-semibold mb-2 text-blue-700">Section 1. Definitions</h2>
          <div className="pl-4 mb-4">
            <p className="mb-2">
              <span className="font-bold">Content:</span> Information, graphics, products, features, functionality, services, and links on the One Union Solutions platform.
            </p>
            <p className="mb-2">
              <span className="font-bold">One Union Solutions:</span> One Union Solutions, its parent and its affiliated and subsidiary companies, any of which may exercise the rights and privileges afforded One Union Solutions under this agreement, but One Union Solutions is the sole obligor under these Terms of Use.
            </p>
            <p className="mb-2">
              <span className="font-bold">Services:</span> Any and all services accessible on the One Union Solutions platform, including, but not limited to, Quotation Management, Shipment Tracking & Assignment, Support & Live Chat, Invoicing & Accounting, and Notifications & Alerts.
            </p>
            <p className="mb-2">
              <span className="font-bold">You:</span> Yourself and the entity that you represent.
            </p>
          </div>

          <h2 className="text-xl font-semibold mb-2 text-blue-700">Section 2. Use of One Union Solutions Platform</h2>
          <p className="mb-4 pl-4">
            The One Union Solutions platform is provided solely for the use of current and potential One Union Solutions customers to interact with One Union Solutions and may not be used by any other person or entity, or for any other purpose. Specifically, all quotation, tracking, shipment, invoicing, duties & taxes calculation, and other information and services may only be used by current and potential One Union Solutions customers for their own shipments. Use of the platform to provide information to or prepare shipments by or for the benefit of third-party shippers is expressly prohibited.
          </p>
          <p className="mb-4 pl-4">
            The use of non-authorized scripting technologies to obtain information from the One Union Solutions platform or submit information through the platform is strictly prohibited.
          </p>

          <h2 className="text-xl font-semibold mb-2 text-blue-700">Section 3. Platform Registration</h2>
          <p className="mb-4 pl-4">
            You may be required to register to access interactive features on the One Union Solutions platform. Your registration provides you with access to the Services, if you have been authorized to access such Services. The availability of these Services varies by country. In the future, One Union Solutions may add other features that may be accessed through your registered account.
          </p>
          <p className="mb-4 pl-4">
            Certain Services may require additional enrolments or agreements and may be subject to additional terms and conditions.
          </p>
          <p className="mb-4 pl-4">
            By registering on the platform, You agree to provide accurate and current information about Yourself as prompted by the registration pages and maintain and promptly update Your online profile information to keep it accurate and current.
          </p>
          <p className="mb-4 pl-4">
            Some Services are being made available to customers based in some countries and not others. You agree to register only for Services offered on the One Union Solutions platform for the country in which your One Union Solutions account is based.
          </p>
          <p className="mb-4 pl-4">
            When you register, you will select a user ID and password. You are responsible for maintaining the confidentiality of the password and user ID, and you are responsible for all activities that occur under Your password and user ID. You agree to (a) immediately notify One Union Solutions of any unauthorized use of Your user ID and password, and (b) ensure that You exit from Your session at the end of each visit.
          </p>

          <h2 className="text-xl font-semibold mb-2 text-blue-700">Section 4. Changes to the Platform</h2>
          <p className="mb-4 pl-4">
            The One Union Solutions platform and its Content may be changed, deleted or updated at any time without notice.
          </p>

          <h2 className="text-xl font-semibold mb-2 text-blue-700">Section 5. Termination of Use</h2>
          <p className="mb-4 pl-4">
            One Union Solutions may discontinue, suspend or modify the platform at any time without notice, and One Union Solutions may block, terminate or suspend Your and any user's access to the platform at any time without notice for any reason in its sole discretion, even if access continues to be allowed to others. The provisions of Sections 7, 8, 9, 10, 13, 14 and 15 shall survive any termination of this Agreement.
          </p>

          <h2 className="text-xl font-semibold mb-2 text-blue-700">Section 6. Ownership</h2>
          <p className="mb-4 pl-4">
            The One Union Solutions platform and its Content are protected by applicable copyright, trademark and other laws. All rights reserved. Specifically, One Union Solutions does not convey to anyone, through allowing access to the platform, any ownership rights in the platform or in any Content appearing on or made available through the platform. Customer may not copy, modify, translate, transmit, distribute, adapt, reproduce, decompile, reverse engineer or disassemble any part of the platform or its Content.
          </p>

          <h2 className="text-xl font-semibold mb-2 text-blue-700">Section 7. Disclaimer of Warranty</h2>
          <div className="bg-gray-100 p-4 rounded-lg mb-4 pl-4">
            <p className="mb-4">
              THE ONE UNION SOLUTIONS PLATFORM AND ITS CONTENT AND SERVICES ARE PROVIDED "AS IS". ONE UNION SOLUTIONS DISCLAIMS ANY AND ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT, REGARDING ANY SUCH CONTENT AND YOUR ABILITY OR INABILITY TO USE THE PLATFORM AND ITS CONTENT OR ANY OF ONE UNION SOLUTIONS' SERVICES.
            </p>
            <p className="mb-4">
              ONE UNION SOLUTIONS EXPRESSLY DISCLAIMS AND EXCLUDES ALL WARRANTIES REGARDING THE PLATFORM AND ITS CONTENT, SERVICES, AND THE FUNCTIONING OF THE INTERNET WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. ONE UNION SOLUTIONS DOES NOT WARRANT THAT THE PLATFORM OR ANY OF ITS CONTENT OR ANY ONE UNION SOLUTIONS SERVICES WILL MEET ALL OF YOUR OR YOUR CUSTOMERS' REQUIREMENTS OR THAT ITS OPERATIONS WILL BE UNINTERRUPTED OR ERROR FREE, OR THAT ANY DEFECT WITHIN THE PLATFORM OR ANY OF ITS CONTENT OR ANY ONE UNION SOLUTIONS SERVICES WILL BE CORRECTED. FURTHERMORE, ONE UNION SOLUTIONS DOES NOT WARRANT NOR MAKE ANY REPRESENTATION REGARDING THE RESULTS OF YOUR OR YOUR CUSTOMERS' USE OF THE PLATFORM OR ANY OF ITS CONTENT OR ANY ONE UNION SOLUTIONS SERVICES IN TERMS OF CAPABILITY, CORRECTNESS, ACCURACY, RELIABILITY OR OTHERWISE. NO ORAL OR WRITTEN INFORMATION, REPRESENTATION OR ADVICE GIVEN BY ONE UNION SOLUTIONS OR AN AUTHORIZED REPRESENTATIVE OF ONE UNION SOLUTIONS SHALL CREATE A WARRANTY.
            </p>
          </div>

          <h2 className="text-xl font-semibold mb-2 text-blue-700">Section 8. Limitation of Liability</h2>
          <div className="bg-gray-100 p-4 rounded-lg mb-4 pl-4">
            <p className="mb-4">
              YOUR USE OF THE ONE UNION SOLUTIONS PLATFORM AND ITS CONTENT AND ONE UNION SOLUTIONS' SERVICES IS AT YOUR SOLE RISK. UNDER NO CIRCUMSTANCES, INCLUDING BUT NOT LIMITED TO NEGLIGENCE, SHALL ONE UNION SOLUTIONS BE LIABLE TO YOU OR TO ANY PARTY CLAIMING THROUGH YOU FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR OTHER DAMAGES IN TORT, CONTRACT, PRODUCT LIABILITY OR UNDER ANY OTHER THEORY OF LAW RESULTING FROM THE ACCESS TO OR USE OF THE PLATFORM, THE INTERNET, OR YOUR ACCESS TO OR USE OF, OR INABILITY TO ACCESS OR USE THE PLATFORM, THE INTERNET, INCLUDING, WITHOUT LIMITATION, DAMAGES RESULTING FROM LOSS OF USE, PROFITS, DATA, OR BUSINESS, AND DAMAGE TO YOUR INTERNAL COMPUTER SYSTEMS EVEN IF ONE UNION SOLUTIONS, OR AN AUTHORIZED REPRESENTATIVE OF ONE UNION SOLUTIONS, HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            </p>
            <p className="mb-4">
              One Union Solutions will not be liable for Your acts or omissions, including but not limited to, incorrect completion or updating of any enrollment or profile form, failure to implement adequate internal security measures to safeguard Your login credentials or password, or Services or Content provided to or accessed by You (or portions thereof) and its confidentiality or for the acts or omissions of anyone else with an interest in the platform or its Content or any of One Union Solutions' Services. Also, One Union Solutions will not be liable if You violate any of the terms of this Agreement. One Union Solutions will not be liable for loss, damages or delay caused by events One Union Solutions cannot control, including but not limited to, acts of God, weather conditions, mechanical delays, acts of public enemies, war, strikes, civil commotions, or acts or omissions of public authorities (including customs and health officials) with actual or apparent authority. You agree to immediately notify One Union Solutions of any known or suspected unauthorized use of your login credentials or password or any other confidential information relating to One Union Solutions or any known or suspected breach of security.
            </p>
          </div>

          <h2 className="text-xl font-semibold mb-2 text-blue-700">Section 9. Indemnity</h2>
          <p className="mb-4 pl-4">
            You shall bear the risk of loss or damage resulting from Your use of the One Union Solutions platform or its Content or any of the Services. You agree to defend, indemnify and hold harmless One Union Solutions and its respective officers, directors, employees, agents and representatives from any and all claims, demands, damages (including incidental and consequential damages), liabilities, costs, expenses, suits and judgments, including the payment of legal fees arising out of or relating to any of the following:
          </p>
          <ul className="list-disc pl-12 mb-4">
            <li className="mb-2">Your breach of any of these terms and conditions,</li>
            <li className="mb-2">Your activities conducted in connection with the platform, its Content or any of the Services,</li>
            <li className="mb-2">Your failure to abide by any applicable laws or regulations regarding the platform, its Content or any of the Services,</li>
            <li className="mb-2">One Union Solutions' provision of data and information to You (including, without limitation, any errors in the information or any unavailable or incomplete information),</li>
            <li className="mb-2">Authorized or unauthorized uses of the platform, its Content or any of the Services in any manner by You or on Your behalf, directly or indirectly, or</li>
            <li className="mb-2">Your failure to implement adequate internal security measures to safeguard Your login credentials, password or any other data or information provided by One Union Solutions (or any portion thereof) and its confidentiality.</li>
          </ul>

          <h2 className="text-xl font-semibold mb-2 text-blue-700">Section 10. Quotation Management</h2>
          <p className="mb-4 pl-4">
            You acknowledge and understand that all quotations provided through the One Union Solutions platform, including those generated by the Duties & Taxes Calculator or through country-specific IOR formulas, are estimates only and subject to change. One Union Solutions reserves the right to modify pricing at any time before shipment initiation. Even after shipment initiation, prices may change due to external factors, and One Union Solutions will notify you of such changes prior to shipping. This does not apply to duties, taxes, or any destination or origin official local costs, as these depend on the actual fees or amounts which One Union Solutions must pay to official authorities. Due to the nature of these official charges, they may change at any time during the shipment process depending on the service provided and the stage of processing. You acknowledge that final duties, taxes, and local costs may differ from initial estimates based on official authority requirements, assessments, or changes in regulations.
          </p>
          <p className="mb-4 pl-4">
            All quotation requests submitted through the platform are subject to review and approval by One Union Solutions administrators before being finalized. One Union Solutions is not bound by any quotation until it has been formally approved.
          </p>

          <h2 className="text-xl font-semibold mb-2 text-blue-700">Section 11. Shipment Tracking & Assignment</h2>
          <p className="mb-4 pl-4">
            The One Union Solutions platform offers real-time tracking features. One Union Solutions will endeavor to provide accurate tracking information, but does not guarantee the accuracy, completeness, or timeliness of such information. You acknowledge that tracking information may be delayed or incomplete due to factors outside One Union Solutions' control.
          </p>

          <h2 className="text-xl font-semibold mb-2 text-blue-700">Section 12. Support & Live Chat</h2>
          <p className="mb-4 pl-4">
            The platform provides support features including a ticketing system and real-time messaging. Response times are not guaranteed. One Union Solutions reserves the right to categorize, prioritize, and respond to support inquiries at its discretion.
          </p>

          <h2 className="text-xl font-semibold mb-2 text-blue-700">Section 13. Notifications & Alerts</h2>
          <p className="mb-4 pl-4">
            The platform provides system alerts and notifications for events such as new quotation requests, chat initiations, or shipment milestone updates. One Union Solutions does not guarantee the delivery or timeliness of these notifications and you should regularly check the platform for updates.
          </p>

          <h2 className="text-xl font-semibold mb-2 text-blue-700">Section 14. Privacy Policy</h2>
          <p className="mb-4 pl-4">
            The One Union Solutions Privacy Policy governs the use of information acquired from You through the platform.
          </p>

          <h2 className="text-xl font-semibold mb-2 text-blue-700">Section 15. Controlling Law and Severability</h2>
          <p className="mb-4 pl-4">
            These Terms of Use and Your use of the One Union Solutions platform or its Content or any of the Services is governed by and construed in accordance with the laws of the jurisdiction where One Union Solutions is headquartered, excluding its conflict of laws provisions. If for any reason a court of competent jurisdiction finds any provision of these Terms of Use, or a portion thereof, to be unenforceable, that provision shall be enforced to the maximum extent permissible.
          </p>
          <p className="mb-4 pl-4">
            Any cause of action with respect to the One Union Solutions platform or its Content or these Terms of Use must be instituted within one year after the claim or cause of action has arisen or be barred and must be brought in a court of competent jurisdiction within the jurisdiction where One Union Solutions is headquartered.
          </p>

          <h2 className="text-xl font-semibold mb-2 text-blue-700">Section 16. Complete Agreement, Scope, and Modification</h2>
          <p className="mb-4 pl-4">
            These Terms of Use constitute the complete and exclusive agreement between You and One Union Solutions with respect to Your access to and use of the One Union Solutions platform and its related system functionalities, and supersede any and all prior or contemporaneous discussions, statements, understandings, representations, or agreements, whether written or oral, regarding this specific subject matter.
          </p>
          <p className="mb-4 pl-4">
            You acknowledge and agree that these Terms of Use exclusively govern Your access to and interaction with the One Union Solutions platform and associated system functionalities, and explicitly do not constitute or imply any broader business agreement or commercial relationship beyond platform usage. General business terms, conditions, and agreements governing Your commercial relationship with One Union Solutions are separately maintained and can be found at: https://oneunionsolutions.com/terms-and-conditions/
          </p>
          <p className="mb-4 pl-4">
            One Union Solutions reserves the right to modify or amend these Terms of Use at any time without notice. Any changes will be effective immediately upon posting on the platform. Your continued use of the platform following such posting constitutes Your acceptance of the changes.
          </p>
        </div> */}

        {termsAccepted ? (
          <div className="mt-6 flex justify-end">
            <button
              className="px-6 py-2 bg-blue-600 btnBg rounded-lg hover:bg-blue-700 transition-colors shadow-md"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
        ) : (
          <>
            <div className="mt-6 flex items-center p-4 bg-blue-50 rounded-lg border border-blue-100 shadow-inner">
              <input
                type="checkbox"
                id="acceptTerms"
                className="w-5 h-5 text-blue-600 border-blue-300 rounded focus:ring-blue-500"
                checked={isChecked}
                onChange={() => setIsChecked(!isChecked)}
              />
              <label
                htmlFor="acceptTerms"
                className="ml-2 text-gray-700 font-medium"
              >
                I accept all the Terms and Conditions.
              </label>
            </div>

            <div className="mt-6 flex justify-end space-x-4">
              <button
                className="px-6 py-2 bg-gray-400 text-white rounded-lg hover:bg-gray-500 transition-colors shadow-md"
                onClick={handleLogout}
              >
                Cancel
              </button>
              {isChecked ? (
                <button
                  className="px-6 py-2 text-white rounded-lg shadow-md"
                  onClick={handleAccept}
                  style={{
                    background: "linear-gradient(90.52deg, #1c3272 0.45%, #355fd8 99.69%)",
                    border: "none"
                  }}
                >
                  Accept & Continue
                </button>
              ) : (
                <button
                  className="px-6 py-2 bg-gray-300 text-gray-500 rounded-lg cursor-not-allowed shadow-md"
                  disabled
                >
                  Accept & Continue
                </button>
              )}
            </div>

            {showConfirmationModal && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
                <div className="bg-white p-6 rounded-lg shadow-xl w-[90%] max-w-md border border-blue-100">
                  <h3 className="text-lg font-semibold text-blue-700 mb-4">
                    Attention
                  </h3>
                  <p className="text-gray-700 mb-6">
                    If you disagree with our terms and conditions, you will not
                    be able to access our services.
                  </p>
                  <div className="flex justify-end space-x-4">
                    <button
                      className="px-4 py-2 bg-gray-400 text-white rounded-lg hover:bg-gray-500 transition-colors shadow-md"
                      onClick={closeConfirmationModal}
                    >
                      Cancel
                    </button>
                    <button
                      className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors shadow-md"
                      onClick={confirmLogout}
                    >
                      Save & Logout
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TermsModal;